import { useCallback, useMemo } from 'react'

import { useProject } from 'modules/projects/queries'

/**
 * Управление отображением интерфейса проекта (админка → «Отображение интерфейса»).
 * Коды совпадают с реестром бэка `users/ui_visibility.py`; бэк отдаёт список скрытых.
 * Всё, чего нет в списке, показывается — в том числе пока проект грузится.
 */
export enum UiElement {
  MenuPulse = 'menu_pulse',
  MenuDataStatus = 'menu_data_status',
  MenuDataInnovations = 'menu_data_innovations',
  MenuForecast = 'menu_forecast',
  MenuScenariosCompare = 'menu_scenarios_compare',
  MenuApprovals = 'menu_approvals',
  ScenarioTabQuality = 'scenario_tab_quality',
  ScenarioTabCorrections = 'scenario_tab_corrections',
  ScenarioTabForecastCompare = 'scenario_tab_forecast_compare',
  CalcAnomalies = 'calc_anomalies',
  CalcTraining = 'calc_training',
  CalcHistory = 'calc_history',
  CalcScopeFilters = 'calc_scope_filters',
  CalcManualLayers = 'calc_manual_layers',
  CalcAdvanced = 'calc_advanced',
  /** Блок «Детальный анализ драйверов» на вкладке «Прогноз» (SDD 28 §3). */
  ForecastDriverAnalytics = 'forecast_driver_analytics',
}

export const isUiElementVisible = (hidden: readonly string[] | undefined, code: UiElement): boolean =>
  !hidden?.includes(code)

export const useUiVisibility = () => {
  const { project, isLoadingProject } = useProject()
  const hidden = project?.uiHidden

  const hiddenSet = useMemo(() => new Set(hidden ?? []), [hidden])
  const isVisible = useCallback((code: UiElement) => !hiddenSet.has(code), [hiddenSet])

  return { isVisible, isLoadingProject }
}
